<script type="text/javascript">
/* eslint-disable camelcase */
/* eslint-disable no-undef */
/* eslint-disable eqeqeq */

/* 一些公用参数： */

import {
  url,
  urlNew,
  normalSueIDs,
  config,
  configYear,
  company_phone,
  card_keyword,
  area_id,
  year,
  address,
  limitYear,
  id_list,
  feedback_pop_id
} from './api.js'

var share_id = ''
var qd = ''

var meeting = { time: '', address: '' }

/* 一些公用方法： */

// 个位数字转化 - 如日期格式化时'小时'的取值 eg. '9:00 or 09:00'
function formatNumber (n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}
function formatHoure (h) {
  if (h && h.length < 5) return '0' + h
  else return h
}

// 日期格式
function _formatTime (number, format, hour_len) {
  var formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
  var returnArr = []
  var date = new Date(number * 1000)
  returnArr.push(date.getFullYear())
  returnArr.push(formatNumber(date.getMonth() + 1))
  returnArr.push(formatNumber(date.getDate()))
  if (!hour_len || hour_len > 1) {
    returnArr.push(formatNumber(date.getHours()))
  } else {
    returnArr.push(date.getHours())
  }
  returnArr.push(formatNumber(date.getMinutes()))
  returnArr.push(formatNumber(date.getSeconds()))
  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i])
  }
  return format
}
function isLeapYear (year) {
  // 如果年份能被4整除但不能被100整除，或者能被400整除，则为闰年
  return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)
}
function formatTime (number, format, hourLength, monthType = 1) {
  var formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
  var returnArr = []
  // var date = new Date(number * 1000) // 接口获取的数据一般为时间戳的1/1000
  var date = 0
  if (number && number.toString().trim().length > 0) {
    if (number.toString().trim().length < 13) {
      date = new Date(number * 1000) // 接口获取的数据一般为时间戳的1/1000
    } else {
      date = new Date(number)
    }
  // } else { // 未传入时间戳时获取当前时间
  //   number = new Date()
  }
  if (date) {
    let beijingYear = date.getFullYear() // 当前时区的年份
    let beijingMonth = date.getMonth() + 1 // 当前时区的月份
    let beijingDate = date.getDate() // 当前时区的日期
    // 获取UTC时间的小时数：北京时间是UTC+8，所以加上8小时，并处理跨日的情况（时区相差最多12小时故最多只会差1日，北京时间date不会小于UTC时间date）
    const utcHours = date.getUTCHours()
    const utcDate = date.getUTCDate()
    let baseHours = utcHours + 8 // 北京时间小时数，date.getHours()为当前时区的小时数
    let beijingHours = baseHours
    if (baseHours >= 24) { // 小时数跨日，-24
      beijingHours = baseHours - 24
      if (beijingDate <= utcDate) {
        beijingDate += 1
      }
    }
    if (utcDate > beijingDate) {
      beijingDate = utcDate
    }
    // 判断是否跨月：baseHours大于24且date大于当月最大值即为跨月（最多只会差1月）
    const monthsWith31Days = [1, 3, 5, 7, 8, 10, 12]
    let monthLength = 30 // 默认为30天长度
    if (beijingMonth === 2) {
      monthLength = 28 // 2月长度
      if (isLeapYear(beijingYear)) {
        monthLength = 29 // 闰年2月长度
      }
    } else if (monthsWith31Days.includes(beijingMonth)) {
      monthLength = 31 // 31天的月份的长度
    }
    if (baseHours >= 24 && beijingDate > monthLength) {
      beijingDate = 1
      beijingMonth += parseInt(beijingDate / monthLength)
    }
    // 判断是否跨年：month大于12即为跨年（最多只会差1年）
    if (beijingMonth > 12) {
      beijingMonth = beijingMonth % 12
      beijingYear += parseInt(beijingMonth / 12)
    }
    // console.log(number, utcHours, ' || ', beijingHours, beijingDate, beijingMonth, beijingYear)
    // 返回结果：年月日时分秒
    returnArr.push(beijingYear)
    returnArr.push(monthType > 1 ? formatNumber(beijingMonth) : beijingMonth)
    returnArr.push(formatNumber(beijingDate))
    if (!hourLength || hourLength > 1) {
      returnArr.push(formatNumber(beijingHours))
    } else {
      returnArr.push(beijingHours)
    }
    returnArr.push(formatNumber(date.getMinutes()))
    returnArr.push(formatNumber(date.getSeconds()))
    for (var i in returnArr) {
      format = format.replace(formateArr[i], returnArr[i])
    }
  }
  return format
}
// 星期
function getWeek (item) {
  // var date = new Date(item * 1000) // 接口获取的数据一般为时间戳的1/1000
  let day = formatTime(item, 'Y/M/D')
  var date = new Date(day)
  let num = date.getDay()
  let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  return weeks[num]
}

// 效果同 hashParam
// // 获取页面url函数  getPar('sid') 即 area_id
// function getPar(par) {
//     var local_url = document.location.href;
//     var get = local_url.indexOf(par + "=");
//     if (get == -1) {
//         return false;
//     }
//     var get_par = local_url.slice(par.length + get + 1);
//     var nextPar = get_par.indexOf("&");
//     if (nextPar != -1) {
//         get_par = get_par.slice(0, nextPar);
//     }
//     return get_par;
// }

// 效果同 hashParam
// // 截取大会id函数  getQueryString('sid') 即 area_id
// function getQueryString(name) {
//     var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
//     var r = window.location.search.substr(1).match(reg);
//     if (r != null) return (r[2]);
//     return null;
// }
// getQueryString,

let hashParam = {}

function getHash (href) {
  let base = href && typeof href === 'string' && href.length > 0 ? href : window.location.search
  if (base && base.length > 0) {
    base
      .substr(1)
      .split('&')
      .map(item => {
        const arr = item.split('=')
        hashParam[arr[0]] = arr[1]
      })
  }
}

// 登录
let logined = false
function isLogined () {
  console.log('isLogined', localStorage.getItem('logins'))
  if (localStorage.getItem('logins') !== null) {
    // this.token = localStorage.getItem('token');
    logined = true
  } else {
    logined = false
  }
  return logined
}
function changeLogined () {
  // logined === true ? false : true
  logined = !logined
  return logined
}

// 获取服务器时间
function getServerTime () {
  return new Date(
    $.ajax({
      type: 'get',
      url: '/',
      async: false
    }).getResponseHeader('Date')
  )
}

// if(hashParam['sid']){
//   area_id = hashParam['sid'];
// }
// if(hashParam['share']){
//   share_id = hashParam['share'];
// }
// if(hashParam['qd']){
//   qd = hashParam['qd'];
// }

// 对象组成的数组排序 自定义规则 arr.sort(toSort(key, mode, type, primer))
function toSortKey (key, mode, type, primer) {
  /*
      key    排序用的键名
      mode   1升序 0降序
      type   键值数据类型
      primer 数据的解析，如parseInt
  */
  return function (a, b) {
    a = a[key]
    b = b[key]
    // 避免存在值为null的情况
    if (a && b) {
      // 字符串排序
      // eslint-disable-next-line eqeqeq
      if (type == 'string') {
        if (mode) {
          return a.localeCompare(b)
        } else {
          return b.localeCompare(a)
        }
      }
      // 数字排序
      if (type == 'number') {
        mode = mode ? -1 : 1
        if (typeof primer !== 'undefined') {
          a = primer(a)
          b = primer(b)
        }
        if (a < b) {
          return mode * -1
        }
        if (a > b) {
          return mode * 1
        }
        return 1
      }
    }
  }
}

function isReallyNaN (value) {
  let base = value
  let flag = false
  if (typeof value === 'number' && value !== base) {
    flag = true
  }
  return flag
}

// 判断是否是Object
function isObjectKeys (o) {
  return o && typeof o === 'object' && !Array.isArray(o) && Object.keys(o) && Object.keys(o).length > 0
}
function isObject (o) {
  return (typeof o === 'object' || typeof o === 'function') && o !== null
}

// 深拷贝对象与数组
function deepClone (obj) {
  if (!isObject(obj)) {
    // throw new Error('obj 不是一个对象！')
    return obj
  }
  // 迭代递归
  let isArray = Array.isArray(obj) // 数组也是对象，Arry也是引用类型
  let cloneObj = isArray ? [] : {}
  for (let key in obj) {
    if (typeof obj[key] === 'function') {
      // eslint-disable-next-line no-new-func
      cloneObj[key] = new Function('return ' + obj[key].toString())()
    } else {
      cloneObj[key] = isObject(obj[key]) ? deepClone(obj[key]) : obj[key]
    }
  }
  return cloneObj
  // 序列化反序列化法 object or array
  // return JSON.parse(JSON.stringify(obj));
}
function safeDeepClone (obj) {
  // 检查是否支持 structuredClone
  if (typeof structuredClone === 'function') {
    try {
      return structuredClone(obj)
    } catch (e) {
      // 如果不支持的类型，回退到JSON
    }
  }
  // 回退到JSON方法
  try {
    return JSON.parse(JSON.stringify(obj))
  } catch (e) {
    // 最后尝试自定义方法
    return deepClone(obj)
  }
}

// Object比较
function compareObject (obj1, obj2) {
  if (typeof obj1 !== typeof obj2) {
    return false
  } else if (['string', 'number', 'boolean', 'undefined'].includes(typeof obj1)) {
    if (obj1 === obj2) return true
    else return false
  }
  let keys1 = Object.keys(obj1)
  let keys2 = Object.keys(obj2)
  if (keys1.length !== keys2.length) return false
  for (let k of keys1) {
    if (typeof obj1[k] === 'object' && obj1[k] !== null) { // 如果是对象，则再递归对比，如果递归返回false，则直接方法也直接返回false
      if (!compareObject(obj1[k], obj2[k])) return false
    } else if (typeof obj1[k] === 'function' || typeof obj2[k] === 'symbol') { // 如果是function或symbol，转字符串再对比，不匹配则直接返回false
      if (String(obj1[k]) !== String(obj2[k])) return false
    } else { // 最后其他类型用es6得Object.is()来比较，不匹配直接返回false
      if (!Object.is(obj1[k], obj2[k])) return false
    }
  }
  return true // 遍历结束了没有返回false，说明没有问题，这里直接返回true，表示键值全等了
}

// JSON字符串转对象或数组
function formatObject (origin) {
  let res = typeof origin === 'object' ? origin : ''
  if (!res) {
    if (typeof origin === 'string' && (origin.includes('{') || origin.includes('[')) && JSON.parse(origin)) {
      res = JSON.parse(origin)
    }
  }
  return res || ''
}

// 随机数
function setRandom (min, max) {
  var num = parseInt(Math.random() * 100)
  if (num < min || num > max) {
    // console.log('<<< ', num)
    return setRandom(min, max)
  } else {
    // console.log('>>> ', num)
    return num
  }
}

// 图片链接
function getSrc (img, cut) {
  let url = img
  if (img && img.includes('http')) {
    // if (cut) {
    //  url = 'http://vip.msup.com.cn/index.php/xin-bin-api/head?url='+escape(img)+'&size=205x205'
    // }
    // let support = '?imageView2/1/w/200/h/200/q/100'
    let support = '?imageMogr2/auto-orient/thumbnail/!600x600r/gravity/North/crop/600x600/blur/1x0/quality/100'
    // url = (img + '').indexOf('?')!=-1?img:(img+support)
    url = (img + '').indexOf('?') !== -1 ? (img.split('?')[0] + support) : (img + support)
    // url = img
  } else {
    url = require('@/assets/img/null.jpeg')
  }
  return url
}
// 拿到thumbs值
function thumbsUrl (origin, key, index) {
  let url = ''
  let _key = key || 'fileUrl'
  let _origin = formatObject(origin)
  if (_origin) {
    if (Array.isArray(_origin)) {
      let _index = index || 0
      url = (_origin[_index] && _origin[_index][_key]) || ''
    } else {
      url = _origin[_key] || ''
    }
  } else {
    url = origin || ''
  }
  return url
}
// 公司、部门、职位 字段拼接
function formatCompany (company, office, position, mark = ' ', flag = false) {
  let str = (position || '').trim()
  if (flag) {
    // 不删除重复
    // str = company.toString().trim() + (mark || ' ') + office.toString().trim() + (mark || ' ') + str
    str = company ? (company.toString().trim() + (mark || ' ')) : ''
    str += office ? (office.toString().trim() + (mark || ' ')) : ''
    str += (position || '').trim()
  } else {
    // 避免重复拼接，比如：公司名和部门名相同，则只拼接一次
    if (office && office.toString().trim().length > 0 && str.indexOf(office.toString().trim()) !== 0) {
      str = office.toString().trim() + (mark || ' ') + str
    }
    if (company && company.toString().trim().length > 0 && str.indexOf(company.toString().trim()) !== 0) {
      str = company.toString().trim() + (mark || ' ') + str
    }
  }
  return str
}

// 转换Blob对象
function dataURLToBlob (dataurl) {
  // console.log('👉🏻url ', dataurl);
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

// 转换base64
function tirggerFile (_file) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader()
    var file = _file
    var url = ''
    var img_url = ''
    reader.readAsDataURL(file)
    // reader.readAsArrayBuffer(file);
    reader.onload = async function (e) {
      url = this.result.substring(this.result.indexOf(',') + 1)
      img_url = 'data:image/png;base64,' + url
      // resolve(this.result);
      resolve(img_url)
    }
  })
}

// 一键复制文本
function toCopy (text) {
  console.log(text)
  try {
    document.execCommand('copy')
    console.log('copy 复制成功')
    // resolve(true)
  } catch (err) {
    console.error('copy 复制失败: ', err)
    // resolve(false)
  }
}
function copyText (text) {
  return new Promise(async (resolve, reject) => {
    if ('clipboard' in navigator) {
      // console.log("navigator.clipboard.writeText('xxx')"); // new-main
      (async (text) => {
        try {
          await navigator.clipboard.writeText(text)
          console.log('writeText 复制成功')
          resolve(true)
        } catch (err) {
          console.error('writeText 复制失败: ', err)
          resolve(false)
        }
      })(text)
    } else if (isCommandSupported('copy')) {
      // console.log("slect dom -> document.execCommand('copy')"); // limit
      if (document.createRange) {
        // console.log("slect dom —— selectNode"); // limit-new
        const copyDom1 = document.createElement('a')
        copyDom1.innerHTML = text
        copyDom1.display = 'none'
        document.body.appendChild(copyDom1)
        window.getSelection().removeAllRanges()
        let range = document.createRange()
        range.selectNode(copyDom1)
        window.getSelection().addRange(range)
        await toCopy(text)
        document.body.removeChild(copyDom1)
        window.getSelection().removeAllRanges()
      } else {
        // console.log("slect dom —— select —— createTextRange/select"); // limit--old/new
        const copyDom = document.createElement('textarea')
        copyDom.value = text
        copyDom.display = 'none'
        if (document.body.createTextRange) { // only IE5-8
          var textRange = document.body.createTextRange()
          textRange.moveToElementText(copyDom)
          textRange.select()
        } else if (copyDom.select) { // IE9+ and more
          copyDom.focus()
          copyDom.select()
        }
        await toCopy(text)
        document.body.removeChild(copyDom)
      }
    } else {
      reject(new Error('no support'))
    }
  })
}

// 检查当前编辑环境是否支持command(如'copy')命令
function isCommandSupported (command) {
  return document.queryCommandSupported(command)
}
// 检查是否为微信端浏览
function isWeChatBrowser () {
  var ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('micromessenger') !== -1
}
// 检查是否为PC端浏览
function IsPC () {
  var userAgentInfo = navigator.userAgent
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  var flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

// Promise allSettled 封装请求多个接口，并处理结果
function requestAll (options = [], processData, successReq) {
  let promises = []
  for (let item of options) {
    if (typeof item === 'object') {
      const {url, ...params} = item
      promises.push(fetch(url, params).then(r => r.json()))
    } else if (typeof item === 'string') {
      promises.push(fetch(item).then(r => r.json()))
    }
  }

  Promise.allSettled(promises)
    .then(results => {
      // 处理所有成功的结果，同时了解哪些失败了
      results.forEach((result, index) => {
        if (result.status === 'fulfilled') {
          console.log(`Promise ${index} 成功:`, result.value)
        } else {
          console.log(`Promise ${index} 失败:`, result.reason)
        }
      })

      // 处理成功获取的数据
      const resultData = successReq ? results
        .filter(result => result.status === 'fulfilled')
        .map(result => result.value) : results

      // 执行回调函数，传入处理后的数据
      processData(resultData)
    })
}

export default {
  header_height_pc: '130px',
  header_height_mob: '60px',
  timestamp: 24 * 60 * 60 * 1000,
  area_id,
  areaIds: Object.keys(config),
  year,
  address,
  limitYear,
  id_list,
  share_id,
  qd,
  feedback_pop_id,
  company_phone,
  card_keyword,
  url,
  urlNew,
  normalSueIDs,
  config,
  configYear,
  hashParam,
  meeting,
  // getPar,
  formatNumber,
  formatHoure,
  formatTime, // new
  _formatTime, // old
  getWeek,
  getHash,
  getServerTime,
  toSortKey,
  isReallyNaN,
  isObjectKeys,
  isObject,
  deepClone,
  safeDeepClone,
  compareObject,
  setRandom,
  getSrc,
  thumbsUrl,
  formatCompany,
  dataURLToBlob,
  tirggerFile,
  copyText,
  isWeChatBrowser,
  IsPC,
  requestAll,
  logined,
  isLogined,
  changeLogined
}
</script>



// WEBPACK FOOTER //
// src/Global.vue